export function objectify(items, keySelector = (i) => i.id) {
  return items.reduce(
    (acc, item) => ({ ...acc, [keySelector(item)]: item }),
    {}
  );
}

export function reorder(list, startIndex, endIndex) {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
}

export function makeLocaleSort(selector = (x) => x, ascending = true) {
  return ascending
    ? (a, b) => selector(a).toString().localeCompare(selector(b).toString())
    : (a, b) => selector(b).toString().localeCompare(selector(a).toString());
}

export function makeNumericSort(selector = (x) => x, ascending = true) {
  return ascending
    ? (a, b) => selector(a) - selector(b)
    : (a, b) => selector(b) - selector(a);
}

export function makeDateSort(selector = (x) => x, ascending = true) {
  return ascending
    ? (a, b) => new Date(selector(a)) - new Date(selector(b))
    : (a, b) => new Date(selector(b)) - new Date(selector(a));
}

export function wrap(value) {
  return Array.isArray(value) ? value : [value];
}

export function distinct(array, keyFn) {
  const distinctFunct = keyFn || ((x) => x.id);
  var mySet = new Set();
  return array.filter(function (x) {
    var key = distinctFunct(x),
      isNew = !mySet.has(key);
    if (isNew) mySet.add(key);
    return isNew;
  });
}

export function deduplicateByProperty(array, selector = x => x, ignoreNulls = true) {
  return array.reduce((acc, current) => {
    const currentSelected = selector(current);
    if (ignoreNulls && !currentSelected) return acc.concat([current]);
    const x = acc.find(item => selector(item) === currentSelected);
    if (!x) {
      return acc.concat([current]);
    } else {
      return acc;
    }
  }, []);
}
